import { TOptionsEvents } from 'keen-slider';
import KeenSlider from 'keen-slider/react';
import Link from 'next/link';
import React, { useCallback, useEffect } from 'react';
import { shortenName } from '../../../helpers/shortenName';
import { ASSETS_BASE_URL } from '../../../lib/constants';
import { breakpointsForTailwind } from '../../../lib/keen-slider-utilities';
import { UserAvatar } from '../basic/UserAvatar';
import { TrendingAuthorsType } from './TrendingAuthors.types';
import TrendingAuthor from './TrendingAuthor';

type TrendingAuthorsSliderProps = {
  className?: string;
  slider: KeenSlider;
  sliderRef: React.RefObject<HTMLDivElement>;
  authors: TrendingAuthorsType[];
  onLoadMore: (shift: number) => void;
  slidesByBreakpoint: {
    [breakpoint in 'default' | 'sm' | 'md' | 'lg' | 'xl' | '2xl']: number;
  };
  setOptions: (value: TOptionsEvents) => void;
  rightAlignBreakpoint: number;
};

export function TrendingAuthorsSlider({
  authors,
  slider,
  sliderRef,
  onLoadMore,
  setOptions,
  slidesByBreakpoint,
  rightAlignBreakpoint
}: TrendingAuthorsSliderProps) {
  const onSliderMove = (instance: KeenSlider) => {
    const details = instance.details();
    if (details.size - details.relativeSlide <= 15 && details.size % 15 === 0) {
      onLoadMore(15);
    }
  };

  useEffect(() => {
    if (slider) {
      setOptions({
        slidesPerView: slidesByBreakpoint['default'],
        loop: true,
        mode: 'free',
        spacing: 1,
        centered: false,
        move: onSliderMove,
        breakpoints: breakpointsForTailwind({
          sm: {
            slidesPerView: slidesByBreakpoint['sm'],
            mode: 'free',
            centered: false
          },
          md: {
            slidesPerView: slidesByBreakpoint['md'],
            mode: 'snap',
            centered: false
          },
          lg: {
            slidesPerView: slidesByBreakpoint['lg'],
            mode: 'snap',
            centered: false
          },
          xl: {
            slidesPerView: slidesByBreakpoint['xl'],
            mode: 'snap',
            centered: false
          },
          '2xl': {
            slidesPerView: slidesByBreakpoint['2xl'],
            mode: 'snap',
            centered: false
          }
        })
      });
      slider.refresh();
    }
  }, [authors]);

  return (
    <div className="flex items-center h-28" style={{ overflowX: 'clip' }}>
      <div ref={sliderRef} className="keen-slider w-full" style={{ overflow: 'visible' }}>
        {authors.length > 0 &&
          authors.map((author, i) => (
            <div
              className="keen-slider__slide flex justify-center flex-col cursor-pointer hover:z-10 ssm:pl-2"
              style={{ overflow: 'visible' }}
            >
              <TrendingAuthor author={author} rightAlign={i >= rightAlignBreakpoint} />
            </div>
          ))}
      </div>
    </div>
  );
}
